import Plyr from 'plyr';
import Flickity from 'flickity';
import 'flickity-fade';

class PowerUses {
	DOM = {} as { rotator: HTMLElement | null };
	flkty: FlickityInstance;

	constructor() {
		this.cache();
		if (!this.DOM.rotator) return;
		if (window.innerWidth < 1000) {
			this.initRotator();
		}
	}

	cache() {
		this.DOM = {
			rotator: document.querySelector('.js-usesRotator'),
		};
	}

	initRotator() {
		this.flkty = new Flickity(this.DOM.rotator, {
			autoPlay: true,
			cellAlign: 'left',
			pageDots: false,
			pauseAutoPlayOnHover: false,
			prevNextButtons: false,
			wrapAround: true,
		}) as unknown as FlickityInstance;
	}
}
new PowerUses();

class EmberIntro {
	DOM = {} as {
		video: HTMLVideoElement;
		audioToggle: HTMLElement;
	};

	constructor() {
		this.cache();
		if (!this.DOM.video) return;
		this.initEvents();
	}

	cache() {
		this.DOM = {
			video: document.querySelector('.js-emberIntroVideo') as HTMLVideoElement,
			audioToggle: document.querySelector('.js-emberIntroVideoVolumeToggle') as HTMLElement,
		};
	}

	initEvents() {
		this.DOM.audioToggle.addEventListener('click', this.toggleClick.bind(this));
	}

	toggleClick(e: Event) {
		const target = e.currentTarget as HTMLElement;
		console.log(target);
		if (target.classList.contains('active')) {
			target.classList.remove('active');
			this.DOM.video.muted = true;
		} else {
			target.classList.add('active');
			this.DOM.video.muted = false;
		}
	}
}
new EmberIntro();

class FF_EmberModular extends HTMLElement {
	DOM = {} as Record<string, any>;
	flkty: FlickityInstance;

	constructor() {
		super();
		this.cache();
		if (!this.DOM.tabs.length || !this.DOM.rotator) return;
		this.initRotator();
		this.initControls();
		this.events();
	}

	cache() {
		this.DOM = {
			tabs: this.querySelectorAll('.js-tabControl'),
			indicator: this.querySelector('.js-tabIndicator'),
			rotator: this.querySelector('.js-tabSlides'),
		};
	}

	initControls() {
		this.DOM.tabs[0]?.classList.add('js-active');
	}

	initRotator() {
		this.flkty = new Flickity(this.DOM.rotator, {
			pageDots: false,
			prevNextButtons: false,
			fade: true,
		} as any) as unknown as FlickityInstance;
		this.flkty.on('change', this.rotatorSettle.bind(this));
	}

	events() {
		for (let i = 0; i < this.DOM.tabs.length; i++) {
			this.DOM.tabs[i].addEventListener('click', this.tabClick.bind(this, i));
		}
	}

	tabClick(i: number, _e: Event) {
		this.flkty.select(i);
	}

	rotatorSettle(index: number) {
		for (let i = 0; i < this.DOM.tabs.length; i++) {
			this.DOM.tabs[i].classList.remove('js-active');
		}
		this.DOM.tabs[index].classList.add('js-active');
		this.DOM.indicator.style.transform = `translateX(${index * 100}%)`;
	}
}
customElements.define('ember-modular', FF_EmberModular);

class FF_EmberToggleVideo extends HTMLElement {
	active = true;
	DOM = {} as {
		switch: HTMLElement;
		video: HTMLElement;
	};

	constructor() {
		super();
		this.cache();
		if (!this.DOM.switch || !this.DOM.video) return;
		this.events();
	}

	cache() {
		this.DOM = {
			switch: this.querySelector('.js-switch') as HTMLElement,
			video: this.querySelector('.js-video') as HTMLElement,
		};
	}

	events() {
		this.DOM.switch.addEventListener('click', this.toggle.bind(this));
	}

	toggle() {
		if (this.active) {
			this.active = false;
			this.DOM.video.style.transform = `translateY(-50%)`;
			this.DOM.switch.classList.add('js-off');
		} else {
			this.active = true;
			this.DOM.video.style.removeProperty('transform');
			this.DOM.switch.classList.remove('js-off');
		}
	}
}
customElements.define('ember-toggle-video', FF_EmberToggleVideo);

class FF_EmberGallery extends HTMLElement {
	hovering = false;
	index = 0;
	hoverIndex = 0;
	players: GalleryPlayerEntry[] = [];
	playingVideo = 0;
	data: GallerySlideData[] = [];
	DOM = {} as Record<string, any>;
	flkty: FlickityInstance;

	constructor() {
		super();
		this.data = JSON.parse(galleryData);
		this.cache();
		if (!this.DOM.prev || !this.DOM.next || !this.DOM.controlPanel || !this.DOM.rotator) {
			return;
		}
		this.events();
		this.initVideos();
		this.initRotator();
	}

	cache() {
		this.DOM = {
			next: this.querySelector('.js-next'),
			prev: this.querySelector('.js-prev'),
			controlPanel: this.querySelector('.js-controlPanel'),
			dots: this.querySelectorAll('.js-dot'),
			hoverTitle: this.querySelector('.js-hoverTitle'),
			rotator: this.querySelector('.js-rotator'),
			slides: this.querySelectorAll('.js-slide'),
		};
	}

	events() {
		this.DOM.prev.addEventListener('click', this.prevClick.bind(this));
		this.DOM.next.addEventListener('click', this.nextClick.bind(this));
		for (let i = 0; i < this.DOM.dots.length; i++) {
			this.DOM.dots[i].addEventListener('click', this.dotClick.bind(this, i));
			this.DOM.dots[i].addEventListener('mouseenter', this.dotEnter.bind(this, i));
		}
		this.DOM.controlPanel.addEventListener('mouseenter', this.controlEnter.bind(this));
		this.DOM.controlPanel.addEventListener('mouseleave', this.controlLeave.bind(this));
	}

	initVideos() {
		for (let i = 0; i < this.DOM.slides.length; i++) {
			const el = this.DOM.slides[i].querySelector('.js-video');
			let plyr: Plyr | undefined;
			if (el) {
				plyr = new Plyr(el, {
					controls: ['play'],
					loop: { active: true },
					iconUrl: `${templateDirectoryUri}/partials/ember/plyr.svg`,
				});
				if (i === 0) {
					plyr.muted = true;
				} else {
					plyr.muted = false;
				}
			}
			this.players.push({
				plyr: plyr,
			});
		}
	}

	initRotator() {
		this.flkty = new Flickity(this.DOM.rotator, {
			pageDots: false,
			prevNextButtons: false,
		}) as unknown as FlickityInstance;
		this.flkty.on('change', this.rotatorChange.bind(this));
	}

	prevClick() {
		this.flkty.previous();
	}
	nextClick() {
		this.flkty.next();
	}
	dotClick(i: number) {
		this.flkty.select(i);
	}
	dotEnter(index: number) {
		this.hoverIndex = index;
		for (let i = 0; i < this.DOM.dots.length; i++) {
			this.DOM.dots[i].classList.remove('js-active');
		}
		this.DOM.dots[index].classList.add('js-active');
		this.DOM.hoverTitle.innerHTML = this.data[index].title;
	}
	controlEnter() {
		this.hovering = true;
	}
	controlLeave() {
		this.hovering = false;
		for (let i = 0; i < this.DOM.dots.length; i++) {
			this.DOM.dots[i].classList.remove('js-active');
		}
		this.DOM.dots[this.index].classList.add('js-active');
		this.DOM.hoverTitle.innerHTML = this.data[this.index].title;
	}
	rotatorChange(index: number) {
		this.index = index;
		for (let i = 0; i < this.DOM.dots.length; i++) {
			this.DOM.dots[i].classList.remove('js-active');
		}
		if (index === this.DOM.dots.length - 1) {
			this.DOM.next.disabled = true;
		} else {
			this.DOM.next.disabled = false;
		}
		if (index === 0) {
			this.DOM.prev.disabled = true;
		} else {
			this.DOM.prev.disabled = false;
		}
		if (this.players[this.playingVideo].plyr) {
			this.players[this.playingVideo].plyr.pause();
		}
		if (this.players[index].plyr) {
			void Promise.resolve(this.players[index].plyr.play()).catch(() => {});
		}
		this.playingVideo = index;

		if (this.hovering) return;
		this.DOM.dots[index].classList.add('js-active');
		this.DOM.hoverTitle.innerHTML = this.data[index].title;
	}
}
customElements.define('ember-gallery', FF_EmberGallery);
